import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormControlsTitle, TwoFactorTitle } from "../../../../../Constants/Constants";
import EmailVerification from "./EmailVerification";
import TwoFactorAuthentication from "./TwoFactorAuthentication";

const TwoFactorContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TwoFactorTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <TwoFactorAuthentication />
          <EmailVerification />
        </Row>
      </Container>
    </>
  );
};
export default TwoFactorContainer;
